function ImageLoad(Element)
{
	var ImageList =
	[];
	GetDelayedImages(Element, ImageList);
	for ( var i = 0; i < ImageList.length; i++)
	{
		var Img = ImageList[i];

		// The reverse fading of images is too resource intensive in large
		// databases
		// StartFader(Img);
		Img.src = Img.getAttribute('image');
	}
}

function GetDelayedImages(element, ImageList)
{
	element = element || document;

	var Elements = element.getElementsByTagName('*');
	for (var i = 0; i < Elements.length; i++)
	{
		if (hasClass(Elements[i], 'ImageDelay'))
		{
			ImageList.push(Elements[i]);
		}
	}
}

function ImageLoader(img, src)
{
	this.img = img;
	this.src = src;
	this.opc = 0;
	SetOpacity(this.img, 0);
}

ImageLoader.prototype.fade = function()
{
	if (this.opc == 0)
	{
		this.img.src = this.src;
	}
	SetOpacity(this.img, this.opc);
	this.opc += 10;
	var oop = this;
	if (this.opc < 101)
	{
		setTimeout(function()
		{
			oop.fade();
		}, 10);
	}
};

function SetOpacity(obj, opc)
{
	if ((opc >= 0) && (opc <= 100))
	{
		obj.style.filter = 'alpha(opacity=' + opc + ')';
		obj.style.opacity = obj.style.MozOpacity = obj.style.KhtmlOpacity = opc / 100 - .001;
	}
}

function StartFader(Img)
{
	var MyImage = new ImageLoader(Img, Img.getAttribute('image'));
	MyImage.fade();
}

function ImageLoadError(Img)
{
	if (Img.parentNode)
	{
		Img.parentNode.innerHTML = "n/a";
	}
}
